import { AllowedLang } from '@/context/user-info';
import {
  barcelonaLogo,
  bordeauxLogo,
  malagaLogo,
  niceLogo,
  parisLogo,
  sevillaLogo,
  toulouseLogo,
  valenciaLogo,
  zaragozaLogo,
} from './images';

export const languageSelection = [
  {
    label: 'ES',
    value: 'es' as AllowedLang,
  },
  {
    label: 'EN',
    value: 'en' as AllowedLang,
  },
  {
    label: 'FR',
    value: 'fr' as AllowedLang,
  },
  {
    label: 'CA',
    value: 'ca' as AllowedLang,
  },
  {
    label: 'IT',
    value: 'it' as AllowedLang,
  },
];

export enum CitiesEnum {
  BARCELONA = 1,
  BORDEAUX = 2,
  VALENCIA = 3,
  PARIS = 4,
  SEVILLA = 5,
  MALAGA = 6,
  TOULOUSE = 7,
  NICE = 8,
  ZARAGOZA = 9,
}

export const yegoCities = [
  {
    value: 'Barcelona',
    label: 'Barcelona',
    country: {
      es: 'España',
      en: 'Spain',
      ca: 'Espanya',
      fr: 'Espagne',
    },
    logo: barcelonaLogo,
    hasAgreement: {
      body: {
        1: 'translation:driving_lessons.section3.selected.city_barcelona.body1',
        2: 'translation:driving_lessons.section3.selected.city_barcelona.body2',
        3: '',
      },
      link: 'https://raccstart.club/curso-de-iniciacion-yego/',
    },
  },
  {
    value: 'València',
    label: 'València',
    country: {
      es: 'España',
      en: 'Spain',
      ca: 'Espanya',
      fr: 'Espagne',
    },
    logo: valenciaLogo,
    hasAgreement: {
      body: {
        1: 'translation:driving_lessons.section3.selected.city_valencia.body1',
        2: 'translation:driving_lessons.section3.selected.city_valencia.body2',
        3: 'translation:driving_lessons.section3.selected.city_valencia.body3',
      },
    },
  },
  {
    value: 'Málaga',
    label: 'Málaga',
    country: {
      es: 'España',
      en: 'Spain',
      ca: 'Espanya',
      fr: 'Espagne',
    },
    logo: malagaLogo,
    hasAgreement: {
      body: {
        1: 'translation:driving_lessons.section3.selected.city_malaga.body1',
        2: 'translation:driving_lessons.section3.selected.city_malaga.body2',
        3: 'translation:driving_lessons.section3.selected.city_malaga.body3',
      },
    },
  },
  {
    value: 'Sevilla',
    label: 'Sevilla',
    country: {
      es: 'España',
      en: 'Spain',
      ca: 'Espanya',
      fr: 'Espagne',
    },
    logo: sevillaLogo,
    hasAgreement: {
      body: {
        1: 'translation:driving_lessons.section3.selected.city_sevilla.body1',
        2: 'translation:driving_lessons.section3.selected.city_sevilla.body2',
        3: 'translation:driving_lessons.section3.selected.city_sevilla.body3',
      },
    },
  },
  {
    value: 'Paris',
    label: 'Paris',
    country: {
      es: 'Francia',
      en: 'France',
      ca: 'França',
      fr: 'France',
    },
    logo: parisLogo,
    hasAgreement: {
      body: {
        1: 'translation:driving_lessons.section3.selected.city_paris.body1',
        2: 'translation:driving_lessons.section3.selected.city_paris.body2',
        3: '',
      },
      school: 'Easy Monneret',
      hours: 1,
      price: 50,
      link: 'https://www.easymonneret.com/fr/products/initiation-scooter-electrique-yego',
    },
  },
  {
    value: 'Bordeaux',
    label: 'Bordeaux',
    country: {
      es: 'Francia',
      en: 'France',
      ca: 'França',
      fr: 'France',
    },
    logo: bordeauxLogo,
  },
  {
    value: 'Toulouse',
    label: 'Toulouse',
    country: {
      es: 'Francia',
      en: 'France',
      ca: 'França',
      fr: 'France',
    },
    logo: toulouseLogo,
    hasAgreement: {
      body: {
        1: 'translation:driving_lessons.section3.selected_city1',
        2: 'translation:driving_lessons.section3.selected_city2',
        3: '',
      },
      school: 'Ecf Compans Toulouse',
      hours: 1,
      price: 40,
      link: 'https://www.ecf.asso.fr/Auto-ecole/Sud-Ouest-Toulouse/ECF-SEPT-DENIERS-Toulouse-TOULOUSE/Nos-Formations-Auto-Ecole/Deux-roues-et-plus/Permis-AM-ex-BSR/INITIATION-YEGO-SCOOTER-ELECTRIQUE',
    },
  },
  {
    value: 'Nice',
    label: 'Nice',
    country: {
      es: 'Francia',
      en: 'France',
      ca: 'França',
      fr: 'France',
    },
    logo: niceLogo,
  },
  {
    value: 'Zaragoza',
    label: 'Zaragoza',
    country: {
      es: 'España',
      en: 'Spain',
      ca: 'Espanya',
      fr: 'Espagne',
    },
    logo: zaragozaLogo,
  },
];
